import React from "react";
import { Link } from "react-router-dom";
import { Eye, ArrowLeft } from "lucide-react";
import { useAuth } from "../context/AuthContext";

const STAFF_ROLES = ["admin", "manager", "cashier"];

// Slim bar shown across the customer storefront when a staff member is
// signed in. Reminds them they're not browsing as a real customer and gives
// a quick path back to the admin console.
export default function StaffPreviewBanner() {
  const { user } = useAuth();
  if (!user || !STAFF_ROLES.includes(user.role)) return null;
  const roleLabel = { admin: "Admin", manager: "Manager", cashier: "Cashier" }[user.role] || user.role;

  return (
    <div className="bg-[#1C2826] text-white text-xs sm:text-sm" data-testid="staff-preview-banner">
      <div className="max-w-7xl mx-auto px-3 sm:px-4 py-1.5 flex items-center justify-between gap-2">
        <div className="flex items-center gap-2 min-w-0">
          <Eye className="h-3.5 w-3.5 text-[#F3C97A] flex-shrink-0" />
          <span className="truncate">
            <span className="font-bold text-[#F3C97A]">Preview mode</span>
            <span className="text-[#A0AAA7] hidden sm:inline"> — you're viewing the storefront as a customer.</span>
            <span className="text-[#A0AAA7]"> Signed in as <b className="text-white">{user.name}</b> · {roleLabel}.</span>
          </span>
        </div>
        <Link
          to="/admin"
          className="flex-shrink-0 inline-flex items-center gap-1 px-2 py-0.5 rounded bg-[#2F5233] hover:bg-[#1F3D24] font-semibold text-[11px] sm:text-xs whitespace-nowrap"
          data-testid="staff-preview-back-btn"
        >
          <ArrowLeft className="h-3 w-3" /> Back to admin
        </Link>
      </div>
    </div>
  );
}
